import { render, staticRenderFns } from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementWirksamkeitspruefung.vue?vue&type=template&id=28384772&scoped=true"
import script from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementWirksamkeitspruefung.vue?vue&type=script&lang=js"
export * from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementWirksamkeitspruefung.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementWirksamkeitspruefung.vue?vue&type=style&index=0&id=28384772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28384772",
  null
  
)

export default component.exports